import { render, staticRenderFns } from "./SetRemark.vue?vue&type=template&id=5c77d4de&scoped=true&"
import script from "./SetRemark.vue?vue&type=script&lang=js&"
export * from "./SetRemark.vue?vue&type=script&lang=js&"
import style0 from "./SetRemark.vue?vue&type=style&index=0&id=5c77d4de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c77d4de",
  null
  
)

component.options.__file = "SetRemark.vue"
export default component.exports